export default __webpack_public_path__ + "static/media/Prometheus.126b07de.mp3";